import React, { useState, useEffect } from "react";
import {
  AdjustmentCodes,
  SignUp,
  Login,
  Dashboard,
  Users,
  SecurityProfiles,
  Clients,
  BillingStatusCategories,
  ItemCategories,
  TaskStatuses,
  JobStatuses,
  BillingStatuses,
  CompanySettings,
  UserSettings,
  Items,
  BillingGroups,
  TimeSheet,
  Invoicing,
  InvoicePreview,
  InvoiceDetailsPreview,
  Invoices,
  Payments,
  NoMatch,
  CompleteSignUp,
  ForgotPassword,
  ResetPassword,
  UnsubscribeEmail,
  ErrorBoundary,
  BulkInvoicePreview,
  EmailOutreach,
  EmailCampaignEditing,
} from "./content/AllContent"; //This route is used to import in a nicer way all the content pages we need to import.
import Test from "./content/Test";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Noty from "noty";
import "../node_modules/noty/lib/noty.css";
import "../node_modules/noty/lib/themes/mint.css";
import dayjs from "dayjs";
import Cookie from "js-cookie";
import { v4 as uuidv4 } from "uuid";
import PrivateRoute from "./utilities/PrivateRoute";
import TaskBoard from "./content/TaskBoard";
import Exports from "./content/Exports";
import PortalPayments from "./content/PortalPayments";
import ReportUserSummary from "./content/ReportUserSummary";
import TimeByItem from "./content/TimeByItem";
import TimeByDay from "./content/TimeByDay";
import ClientReports from "./content/ClientReports";
import TimeReports from "./content/TimeReports";
import InvoiceReports from "./content/InvoiceReports";
import TaskReports from "./content/TaskReports";
import MailingLabels from "./content/MailingLabels";
import ClientCategories from "./content/ClientCategories";
import AuthLayout from "./utilities/AuthLayout";
import axios from "axios";
import ClientDetails from "./content/ClientDetails";
import _ from "lodash";
import PortalPayment from "./content/PortalPayment";

window.$server_host = process.env.REACT_APP_SERVER_HOST || "localhost";
window.$server_port = process.env.REACT_APP_SERVER_PORT || 3001;

//function passed to components that allows consistent notificaitons.
let last_timestamp = dayjs();
let last_message = "";
function MakeNotification(type, message, delay = 2500, location = "topRight", override = false) {
  if (dayjs().diff(last_timestamp, "seconds") <= 1 && last_message === message) {
    return;
  }
  last_timestamp = dayjs();
  last_message = message;
  if (override)
    return new Noty({
      text: message,
      type: type,
      timeout: delay,
      layout: location,
    }).show();
  return new Noty({
    text: message.split(" ").map(_.capitalize).join(" "),
    type: type,
    timeout: delay,
    layout: location,
  }).show();
}
function FormatNumberToCurrency(val) {
  val = (val + "").replace(/[^[.\d|-]/g, "");
  let formatter = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(Number(val));
}
function FormatPhrase(phrase, option = "titlecase") {
  option = option.toLowerCase();
  if (option === "titlecase" || option === "title case") {
    let modified_phrase = phrase
      .toLowerCase()
      .split(" ")
      .map((e) => {
        return e.charAt(0).toUpperCase() + e.slice(1);
      })
      .join(" ");
    return modified_phrase;
  }

  return phrase;
}
function FormatNumberTwoDecimals(num) {
  if (num < 0.0001 && num > -0.0001) return Number(0).toFixed(2); //this handles odd exceptions of javascript rounding issues where we get numbers to the power of -13 and dumb stuff like that
  num = (num + "").replace(/[^[.\d|-]/g, "");
  return Number(num).toFixed(2);
}
function MakeDateTimeReadable(datetime, option = 1) {
  if (!datetime) return "";
  if (datetime === "0000-00-00 00:00:00") return "";

  if (option === 2) return dayjs(datetime).format("MM/DD/YYYY HH:mm:ss");

  let dayjs_date = dayjs(datetime);
  if (dayjs_date) return dayjs_date.format("MM/DD/YYYY");

  return "";
}
function MakeUserOptions(user_list) {
  return [
    {
      label: "Logged In User",
      options: user_list
        .filter((f) => f.current_user === 1)
        .sort((a, b) => {
          let f = (a.first_name + " " + a.last_name).toUpperCase() - (b.first_name + " " + b.last_name).toUpperCase();
          if (f < 0) return -1;
          if (f > 0) return 1;
          return 0;
        })
        .map((m) => {
          return { ...m, label: m.first_name + " " + m.last_name, value: m.id, key: m.id + "li" };
        }),
    },
    {
      label: "Active Users",
      options: user_list
        .filter((f) => f.deleted_at === null)
        .sort((a, b) => {
          let f = (a.first_name + " " + a.last_name).toUpperCase() - (b.first_name + " " + b.last_name).toUpperCase();
          if (f < 0) return -1;
          if (f > 0) return 1;
          return 0;
        })
        .map((m) => {
          return { ...m, label: m.first_name + " " + m.last_name, value: m.id, key: m.id + "au" };
        }),
    },
    {
      label: "Inactive Users",
      options: user_list
        .filter((f) => f.deleted_at !== null)
        .sort((a, b) => {
          let f = (a.first_name + " " + a.last_name).toUpperCase() - (b.first_name + " " + b.last_name).toUpperCase();
          if (f < 0) return -1;
          if (f > 0) return 1;
          return 0;
        })
        .map((m) => {
          return { ...m, label: m.first_name + " " + m.last_name, value: m.id, key: m.id + "iu" };
        }),
    },
  ];
}
function MakeJobTaskOptions(task_list, completed_status) {
  if (completed_status)
    return [
      {
        label: "Active Tasks",
        options: task_list
          .filter((t) => t.task_status_id !== completed_status.id)
          .sort((a, b) => {
            let f = (a.job_name + " > " + a.description).toUpperCase() - (b.job_name + " > " + b.description).toUpperCase();
            if (f < 0) return -1;
            if (f > 0) return 1;
            return 0;
          })
          .map((t) => {
            return { ...t, label: t.job_name + " > " + t.description, value: t.job_id + "-" + t.task_id, jobs_xref: t.job_id, tasks_xref: t.task_id };
          }),
      },
      {
        label: "Completed Tasks",
        options: task_list
          .filter((t) => t.task_status_id === completed_status.id)
          .sort((a, b) => {
            let f = (a.job_name + " > " + a.description).toUpperCase() - (b.job_name + " > " + b.description).toUpperCase();
            if (f < 0) return -1;
            if (f > 0) return 1;
            return 0;
          })
          .map((t) => {
            return { ...t, label: t.job_name + " > " + t.description, value: t.job_id + "-" + t.task_id, jobs_xref: t.job_id, tasks_xref: t.task_id };
          }),
      },
    ];

  return [
    {
      label: "Tasks",
      options: task_list
        .sort((a, b) => {
          let f = (a.job_name + " > " + a.description).toUpperCase() - (b.job_name + " > " + b.description).toUpperCase();
          if (f < 0) return -1;
          if (f > 0) return 1;
          return 0;
        })
        .map((t) => {
          return { ...t, label: t.job_name + " > " + t.description, value: t.job_id + "-" + t.task_id };
        }),
    },
  ];
}
function MakeJobOptions(jobs, completed_status) {
  let ordered_jobs = jobs
    .map((m) => {
      return { ...m, value: m.id, label: m.name };
    })
    .sort((a, b) => (a.id < b.id ? 1 : -1));
  return ordered_jobs;
}
function MakeTaskOptions(tasks, completed_status) {
  let orderd_mapped_tasks = tasks
    .map((m) => {
      return { ...m, value: m.id, label: m.description };
    })
    .sort((a, b) => (a.id - b.id ? -1 : 1));
  if (completed_status)
    return [
      {
        label: "Active Tasks",
        options: orderd_mapped_tasks.filter((t) => t.task_statuses_xref !== completed_status.id),
      },
      {
        label: "Completed Tasks",
        options: orderd_mapped_tasks.filter((t) => t.task_statuses_xref === completed_status.id),
      },
    ];
  return [
    {
      label: "Tasks",
      options: orderd_mapped_tasks,
    },
  ];
}
function MakeClientOptions(client_list) {
  return client_list
    .sort((e1, e2) => {
      let e1u = e1.name.toUpperCase();
      let e2u = e2.name.toUpperCase();
      if (e1u < e2u) return -1;
      if (e1u > e2u) return 1;
      return 0;
    })
    .map(function (e) {
      return { ...e, label: e.name, value: e.id };
    });
}
const default_rangepicker_presets = [
  {
    label: "Last 7 Days",
    value: [dayjs().add(-7, "d"), dayjs()],
  },
  {
    label: "This Month",
    value: [dayjs().startOf("month"), dayjs().endOf("month")],
  },
  {
    label: "Year to Date",
    value: [dayjs().startOf("year"), dayjs()],
  },
  {
    label: "Last Month",
    value: [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")],
  },
  {
    label: "Last Year",
    value: [dayjs().subtract(1, "year").startOf("year"), dayjs().subtract(1, "year").endOf("year")],
  },
  {
    label: "Last Year to Date",
    value: [dayjs().subtract(1, "year").startOf("year"), dayjs()],
  },
];

function App(props) {
  const navigate = useNavigate();
  const [authToken, setAuthToken] = useState(Cookie.get("x-access-token"));
  const [tokenExpirationDate, setTokenExpirationDate] = useState(Cookie.get("x-access-token-expiration"));
  const [userPreferences, setUserPreferences] = useState(null);
  const [securitySettings, setSecuritySettings] = useState(
    Cookie.get("security-settings") === undefined || Cookie.get("security-settings") === "undefined" ? "" : JSON.parse(Cookie.get("security-settings")),
  );
  const [relogRequired, setRelogRequired] = useState(false);
  const AxiosRequest = async (slug, data = {}, suppress_notification = false) => {
    try {
      let response = await axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + slug, {
        ...data,
        idemp_token: uuidv4(),
        "x-access-token": authToken,
      });

      if (response.status === 409) return;
      if (response.data.status === "error" && response.data.message) {
        props.MakeNotification(response.data.status || "success", response.data.message);
        return response;
      }
      if (suppress_notification) return response;
      if (response.data.message) props.MakeNotification(response?.data?.status.toLowerCase() || "success", response.data.message, response?.data?.sticky_message ? false : 2500);
      if (response.status === 200) return response;
    } catch (error) {
      console.log(error);
    }
  };

  const GetUserPreferences = async () => {
    let response = await AxiosRequest("/api/user/get/self");
    setUserPreferences(response.data.user);
  };
  const GetUserSecurityProfile = async () => {
    let response = await props.AxiosRequest("/api/security-profile/get");
    if (response.data.status === "success") setSecuritySettings(response.data.data);
  };
  props = {
    ...navigate,
    ...props,
    authToken,
    AxiosRequest,
    MakeNotification,
    MakeDateTimeReadable,
    FormatNumberToCurrency,
    setRelogRequired,
    FormatNumberTwoDecimals,
    FormatPhrase,
    securitySettings,
    MakeUserOptions,
    MakeJobTaskOptions,
    MakeJobOptions,
    MakeTaskOptions,
    MakeClientOptions,
    default_rangepicker_presets,
    userPreferences,
  };
  useEffect(() => {
    if (authToken) {
      GetUserPreferences();
      GetUserSecurityProfile();
    }
  }, [authToken]);
  useEffect(() => {
    let checkTokenExpiration = setInterval(() => {
      if (tokenExpirationDate && dayjs(tokenExpirationDate).diff(dayjs(), "seconds") <= 0) {
        try {
          Cookie.remove("x-access-token");
          Cookie.remove("x-access-token-expiration");
          MakeNotification("info", "Your session has expired. Logging out.");
          setTokenExpirationDate(null);
          navigate("/");
          setAuthToken(null);
        } catch (e) {
          console.log(e);
          document.location.href = "my.firmtamer.com/auth/login";
        }
      }
    }, 5000);
    return () => {
      clearInterval(checkTokenExpiration);
    };
  }, [tokenExpirationDate, navigate]);

  return (
    <>
      {/* Pathing for non-layout routes */}
      <Routes>
        <Route exact path="/" element={<Login {...props} setAuthToken={setAuthToken} setTokenExpirationDate={setTokenExpirationDate} setSecuritySettings={setSecuritySettings} />} />
        <Route exact path="/auth/forgot-password" element={<ForgotPassword {...props} />} />
        <Route exact path="/auth/reset-password/:link" element={<ResetPassword {...props} />} />
        <Route exact path="/auth/sign-up" element={<SignUp {...props} />} />
        <Route exact path="/auth/sign-up/promo/:promo" element={<SignUp {...props} />} />
        <Route exact path="/auth/complete-sign-up/:link" element={<CompleteSignUp {...props} />} />
        <Route exact path="/auth/login" element={<Login {...props} setAuthToken={setAuthToken} setTokenExpirationDate={setTokenExpirationDate} setSecuritySettings={setSecuritySettings} />} />
        <Route exact path="/mailing-labels/:type" render={({ match, location }) => <MailingLabels {...props} {...location} {...match} />} />
        <Route exact path="/portal/payments/:company_tag" element={<PortalPayment {...props} />} />
        {/* <Route exact path="/portal/client-payment/:company_tag-:client_tag" render={({ match }) => <PortalClient {...props} match={match} />} /> */}
        <Route {...props} path="/portal/payments-direct/c/:client_tag/i/:invoice_tag" element={<PortalPayment {...props} />} />
        <Route {...props} path="/portal/payments-client/f/:company_tag/c/:client_tag" element={<PortalPayment {...props} />} />
        <Route {...props} path="/portal/payments-firm/f/:company_tag" element={<PortalPayment {...props} />} />
        <Route exact path="/email-preferences/unsubscribe/" render={(props) => <UnsubscribeEmail {...props} />} />
        <Route exact path="/email-preferences/unsubscribe/:recipients" render={({ match }) => <UnsubscribeEmail {...props} match={match} />} />

        {/* PRIVATE ROUTES START */}
        <Route path="/" element={<PrivateRoute {...props} />}>
          {/* This PrivateRoute handles if users have logged in and have an authtoken */}
          <Route {...props} exact path="/invoice-preview" element={<InvoicePreview {...props} />} />
          <Route {...props} exact path="/invoice-preview/:invoice_tag" element={<InvoicePreview {...props} />} />
          <Route {...props} exact path="/invoice-preview-with-details/:invoice_tag" element={<InvoicePreview {...props} />} />
          <Route {...props} exact path="/bulk-invoice-preview" element={<BulkInvoicePreview {...props} />} />
          <Route {...props} exact path="/invoice-details-preview" element={<InvoiceDetailsPreview {...props} />} />
          <Route path="/" element={<AuthLayout {...props} setAuthToken={setAuthToken} />}>
            <Route {...props} path="/clients" element={<Clients {...props} />} />
            <Route {...props} path="/dashboard" element={<Dashboard {...props} />} />
            <Route {...props} path="/task-board" element={<TaskBoard {...props} />} />
            <Route {...props} path="/users" element={<Users {...props} />} />
            <Route {...props} path="/security-profiles" element={<SecurityProfiles {...props} />} />
            <Route {...props} path="/invoicing" element={<Invoicing {...props} />} />
            <Route {...props} path="/invoicing/:invoice_tag" element={<Invoicing {...props} />} />
            <Route {...props} path="/invoices" element={<Invoices {...props} />} />
            <Route {...props} path="/payments" element={<Payments {...props} />} />
            <Route {...props} path="/export-invoices" element={<Exports {...props} />} />
            <Route {...props} path="/exports" element={<Exports {...props} />} />
            <Route {...props} path="/email-outreach" element={<EmailOutreach {...props} />} />
            <Route {...props} path="/email-campaigns/:campaign_tag" element={<EmailCampaignEditing {...props} />} />
            <Route {...props} path="/client-details/:client_tag" element={<ClientDetails {...props} />} />
            <Route {...props} path="/billing-status-categories" element={<BillingStatusCategories {...props} />} />
            <Route {...props} path="/item-categories" element={<ItemCategories {...props} />} />
            <Route {...props} path="/client-categories" element={<ClientCategories {...props} />} />
            <Route {...props} path="/items" element={<Items {...props} />} />
            <Route {...props} path="/billing-groups" element={<BillingGroups {...props} />} />
            <Route {...props} path="/task-statuses" element={<TaskStatuses {...props} />} />
            <Route {...props} path="/job-statuses" element={<JobStatuses {...props} />} />
            <Route {...props} path="/billing-statuses" element={<BillingStatuses {...props} />} />
            <Route {...props} path="/company-settings" element={<CompanySettings {...props} />} />
            <Route {...props} path="/user-settings" element={<UserSettings {...props} />} />
            <Route {...props} path="/adjustment-codes" element={<AdjustmentCodes {...props} />} />
            <Route {...props} path="/time-sheet" element={<TimeSheet {...props} />} />
            <Route {...props} path="/reports/client-reports" element={<ClientReports {...props} />} />
            <Route {...props} path="/reports/time-reports" element={<TimeReports {...props} />} />
            <Route {...props} path="/reports/task-reports" element={<TaskReports {...props} />} />
            <Route {...props} path="/reports/invoice-reports" element={<InvoiceReports {...props} />} />
            <Route {...props} path="/reports/user-summary" element={<ReportUserSummary {...props} />} />
            <Route {...props} path="/reports/time-by-item" element={<TimeByItem {...props} />} />
            <Route {...props} path="/reports/time-by-day" element={<TimeByDay {...props} />} />
          </Route>
        </Route>
        <Route {...props} exact path="/*" element={<NoMatch {...props} />} />
      </Routes>
    </>
  );
}

export default App;
